import { meta } from "./_meta";
import styles from './_hcp-view-pi.module.scss';

export default function HcpViewPi() {
  
  return (
      <div className={styles.container}>
        <div className="container">

          <div className={styles.pdf_frame}>
              <iframe src="https://www.neurocrine.com/crenessitypi#view=FitH&navpanes=0" title="Crenessity Full Prescribing Information PDF" frameBorder="0" allowFullScreen></iframe>
          </div>

        </div>
      </div>
  );
}

HcpViewPi.getLayoutProps = (_pageProps, _router) => ({
  customClass: styles.layout,
  meta,
  hero: null,
});